const reportActionTypes = {
  GET_USER_COUNT: 'GET_USER_COUNT',
  SET_USER_COUNT: 'SET_USER_COUNT',
  GET_APP_REPORT: 'GET_APP_REPORT',
  GET_FLAGGED_CANCEL_REPORT: 'GET_FLAGGED_CANCEL_REPORT',
  SET_ADMIN_APP_REPORT: 'SET_ADMIN_APP_REPORT',
  SET_BUILDING_APP_REPORT: 'SET_BUILDING_APP_REPORT',
  SET_LANDLORD_APP_REPORT: 'SET_LANDLORD_APP_REPORT',
  SET_FLAGGED_CANCEL_REPORT: 'SET_FLAGGED_CANCEL_REPORT',
  GET_BUILDING_COUNT: 'GET_BUILDING_COUNT',
  SET_BUILDING_COUNT: 'SET_BUILDING_COUNT',
  GET_LANDLORD_COUNT: 'GET_LANDLORD_COUNT',
  SET_LANDLORD_COUNT: 'SET_LANDLORD_COUNT',
  SET_USER_COUNT_ERROR: 'SET_USER_COUNT_ERROR',
  SET_BUILDING_COUNT_ERROR: 'SET_BUILDING_COUNT_ERROR',
  SET_APP_REPORT_ERROR: 'SET_APP_REPORT_ERROR',
  GET_USER_REPORT: 'GET_USER_REPORT',
};

export default reportActionTypes;
